import {
    Box,
    Button,
    Divider,
    FormControl,
    Grid,
    Modal,
    TextField,
  } from "@mui/material";
  import { ModalHeader } from "../../common/modalHeader";
  import { useEffect, useState } from "react";
  import { addReduceReason, getReduceStockDetails } from "./stockApi";
  
  export const ReducePop = ({ open, setOpen, data, setData,next }) => {
    const [formData, setFormData] = useState(null);
    useEffect(() => {
        console.log("datadatadata = ", data);
        if (data && open && Object.keys(data).length > 0) {
          getReduceStockDetails(
            {
              rawMaterialId: data.rawMaterialId,
              page: 1,
              pageSize: 1000,
            },
            (data) => { 
            }
          );
          
        } else {
          
        }
      }, [open]);
  
    
    return (
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            background: "white",
            width: {md:"52%", xs:"95%"},
            overflowY: "auto",
            height: "auto",
            position: "absolute",
            left: {xs:"2%", md:"25%"},
            top: "10%",
          }}
        >
          <ModalHeader
            title={"Reason"}
            onClose={(data) => {
              setOpen(data);
            }}
          />
  
          <Divider />
          <Grid
            conta 
            spacing={2}
            sx={{
              padding: "20px",
            }}
          >
            <Grid item xs={12} sm={12}>
           
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControl fullWidth>
                <TextField
                  label="Reason"
                  name="reason"
                  value={formData?.reason}
                  onChange={(e) => {
                    setFormData({ ...formData, reason: e.target.value });
                  }}
                  required
                  InputLabelProps={{ className: "mulish" }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                type="submit"
                variant="contained"
                onClick={() => {
                

                    setOpen(false)
                  next(true)
                }}
                color="primary"
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    );
  };
  